<template>
  <!-- Card 17trt6jcyfb: o tutor acompanha os exercicios dos alunos Autonomy
       (sem professor) designados a ele. -->
  <div class="tex">
    <div class="tex__inner">
      <h1 class="tex__title">{{ $t("tutored.title") }}</h1>
      <p class="tex__lead">
        {{ $t("tutored.lead") }}
      </p>
      <student-exercise-overview :empty-text="$t('tutored.empty')" />
    </div>
  </div>
</template>

<script>
import StudentExerciseOverview from "@/components/exercises/StudentExerciseOverview.vue";

export default {
  name: "TutoredExercises",
  components: { StudentExerciseOverview },
};
</script>

<style lang="scss" scoped>
.tex {
  min-height: 100%;
  background: var(--dk-wash, #f6f2fb);
  padding: clamp(20px, 4vw, 44px) 16px 80px;
}

.tex__inner {
  max-width: 820px;
  margin: 0 auto;
}

.tex__title {
  margin: 0;
  font-family: "Poppins", sans-serif;
  font-weight: 600;
  font-size: clamp(26px, 4vw, 34px);
  color: var(--dk-ink, #2b2540);
}

.tex__lead {
  margin: 8px 0 20px;
  font-size: 14.5px;
  line-height: 1.6;
  color: var(--dk-muted, #7a7590);
  max-width: 60ch;
}
</style>
